export default __webpack_public_path__ + "static/media/sloganBgMb.f8600df8.png";